import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EquipmentUtils from 'utils/EquipmentUtils';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import { getPinResetEquipment } from '../../utils/pinResetUtils';
import FontIcon from 'material-ui/FontIcon';
import Loading from 'layoutComponents/Loading';
import { hitActionRegistered, equipmentHitAllMessageBuilder } from '../../utils/helper';

class OutletActionBar extends PureComponent {
    constructor(props, context) {

        super(props, context);


        this.state = {
            showPinResetButtons: false,
        };

        this.state = { open: false };

        this.hitAll = this
            .hitAll
            .bind(this);

        this.sendBalancingHit = this.sendBalancingHit.bind(this);

        this.updateOutlets = this
            .updateOutlets
            .bind(this);

        this.removeAll = this
            .removeAll
            .bind(this);

        this.resetOutlets = this
            .resetOutlets
            .bind(this);

        this.handleInventoryReload = this
            .handleInventoryReload
            .bind(this);

        this.showHitAllDialog = this.showHitAllDialog.bind(this);
        this.hideHitAllDialog = this.hideHitAllDialog.bind(this);
        this.togglePinResetButtons = this.togglePinResetButtons.bind(this);
        this.pinResetCall = this.pinResetCall.bind(this);
    }

    updateOutlets(e) {
        e.preventDefault();
        const { equipmentDetails, orderId, workOrderActions, userId, orderUserId } = this.props;
        const equipment = equipmentDetails.get('details');
        const isSelf = userId === orderUserId;

        workOrderActions.outletUpdateStarted(equipment, orderId, orderUserId, isSelf);

    }

    resetOutlets(e) {
        e.preventDefault();
        const { orderId, workOrderActions, equipmentDetails } = this.props;

        const equipment = equipmentDetails.get('details');

        equipment.forEach((outlet) => {
            workOrderActions.outletUpdate({
                orderId: orderId,
                newSerialNumber: outlet.get('originalSerialNumber'),
                outletId: outlet.get('equipmentOutlet')
            });

        });
    }

    handleInventoryReload(e) {
        const { orderUserId, getTechInventoryStarted } = this.props;
        e.preventDefault();

        getTechInventoryStarted({
            isSelf: false
        }, orderUserId);
    }

    removeAll(e) {
        e.preventDefault();
        const { orderId, workOrderActions, equipmentDetails } = this.props;

        const equipment = equipmentDetails.get('details');

        equipment.forEach((outlet) => {
            workOrderActions.outletUpdate({
                orderId: orderId,
                newSerialNumber: '',
                outletId: outlet.get('equipmentOutlet')
            });

        });
    }

    sendBalancingHit(orderId) {
        const { workOrderActions } = this.props;
        workOrderActions.equipmentBalancingHitStarted({
            orderNumber: orderId
        }, orderId);
    }

    hitAll(e) {
        e.preventDefault();
        const { equipmentDetails, orderId, workOrderActions, equipmentHitDetails } = this.props;
        const equipment = equipmentDetails.get('details');
        const registeredEquipmentHit = [];
        let hitSent = false;


        equipment.forEach((outlet) => {
            if (EquipmentUtils.isHitable(outlet)) {
                if (hitActionRegistered(equipmentHitDetails, outlet)) {
                    registeredEquipmentHit.push(outlet.get('seriaNumber'));
                } else {
                    workOrderActions.equipmentHitStarted({
                        serialNumber: outlet.get('seriaNumber')
                    }, orderId);
                    hitSent = true;
                }
            }
        });

        if (registeredEquipmentHit.length > 0) {
            alert(equipmentHitAllMessageBuilder(registeredEquipmentHit));
        }

        if (hitSent) {
            setTimeout(() => {
                this.sendBalancingHit(orderId);
            }, 30000);
        }



        this.setState({ open: false });
    }

    hideHitAllDialog(e) {
        e.preventDefault();
        this.setState({ open: false });
    }

    showHitAllDialog(e) {
        e.preventDefault();
        this.setState({ open: true });
    }

    togglePinResetButtons() {
        this.setState({
            showPinResetButtons: !this.state.showPinResetButtons,
        });
    }

    pinResetCall(types, pinResetEquipment) {
        const {
            workOrderActions,
            orderId,
            orderDetails,
            schedulingSystemDetails
        } = this.props;

        if (
            orderDetails &&
            schedulingSystemDetails &&
            pinResetEquipment &&
            types && types.length > 0
        ) {
            types.forEach(type => {
                workOrderActions.pinResetStarted(
                    orderId,
                    {
                        pinType: type,
                        houseNumber: pinResetEquipment.get('houseNumber'),
                        accountNumber: orderDetails.get('accountNumber'),
                        billingSystem: schedulingSystemDetails.get('billingSystem') &&
                            schedulingSystemDetails.get('billingSystem').toUpperCase()
                    }
                );
            });
        }
    }

    render() {
        const {
            equipmentDetails,
            techInventoryLoading,
            techInventory,
            pinReset,
            workOrderActions,
            orderId,
        } = this.props;
        const { showPinResetButtons } = this.state;

        const confirmBtnStyle = {
            margin: '.25rem'
        };

        const actions = [
            <RaisedButton
                style={confirmBtnStyle}
                label="Cancel"
                primary={true}
                onClick={this.hideHitAllDialog}
                key="hitAllCancelBtn"
            />,
            <RaisedButton
                style={confirmBtnStyle}
                label="Hit All"
                primary={true}
                keyboardFocused={true}
                onClick={this.hitAll}
                key="hitAllBtn"
            />,
        ];


        if (!equipmentDetails || !equipmentDetails.get('details') || equipmentDetails.get('details').count() === 0) {
            return (<div />);
        }

        const equipment = equipmentDetails.get('details');
        const equipmentLoading = equipmentDetails.get('loading');
        const outletsUpdating = equipmentDetails.get('outletUpdateLoading');
        const equipmentValidators = equipmentDetails.get('validators');

        const hitAllButtonStyle = {
            padding: '.25rem'
        },
            removeAllButtonStyle = {
                padding: '.25rem',
                fontSize: '.65rem'
            },
            cancelButtonStyle = {
                padding: '.25rem'
            },
            updateAllButtonStyle = {
                padding: '.25rem'
            },
            pinResetButtonStyle = {
                padding: '.25rem'
            };

        let hasItemsWithUpdate = false;
        let hideAll = false;

        equipment.forEach((item) => {

            if (item.get('action') === 'update') {
                hasItemsWithUpdate = true;
            }

            if (item.get('action') === 'remove') {
                hasItemsWithUpdate = true;
            }

            if (item.get('action') === 'add') {
                hasItemsWithUpdate = true;
            }

            if (item.get('hitStarted')) {
                hideAll = true;
            }

        });

        if (hasItemsWithUpdate) {
            hitAllButtonStyle.display = 'none';
            removeAllButtonStyle.display = 'none';
            cancelButtonStyle.display = 'inline-block';
            updateAllButtonStyle.display = 'inline-block';
        } else {
            hitAllButtonStyle.display = 'inline-block';
            removeAllButtonStyle.display = 'inline-block';
            cancelButtonStyle.display = 'none';
            updateAllButtonStyle.display = 'none';
        }

        if (hideAll) {
            hitAllButtonStyle.display = 'none';
            removeAllButtonStyle.display = 'none';
            cancelButtonStyle.display = 'none';
            updateAllButtonStyle.display = 'none';
        }

        const colStyle = {
            padding: '.25rem',
            fontSize: '.65rem'
        };

        const refreshInventoryLabel = techInventoryLoading
            ? "INV Loading"
            : "Refresh INV";

        // pin reset checking
        const pinResetEquipment = getPinResetEquipment(equipment);

        let loader = null;

        if (pinReset) {
            const [...pinResetTypes] = pinReset.keys();

            pinResetTypes.forEach(type => {
                const pinResetLoading = pinReset.getIn([type, 'loading']);
                const pinResetLoadingFinished = pinReset.getIn([type, 'loadingFinished']);

                if (pinResetLoading && !pinResetLoadingFinished) {
                    loader = (
                        <Loading
                            message="Pin reset..."
                            isLoading={pinResetLoading}
                        />
                    );
                }
            });
        }

        const labelStyle = {
            fontSize: '11px',
            paddingLeft: pinResetEquipment ? '2px' : '8px',
            paddingRight: pinResetEquipment ? '2px' : '8px'

        };

        const pinResetContainerStyle = {
            marginBottom: '.5rem',
            color: '#ffffff',
            fontSize: '11px',
            padding: '0.25rem 0',
        };

        const errorBackgroundColor = 'rgb(244, 67, 54)';
        const successBackgroundColor = 'rgb(76, 175, 80)';

        const pinResetResults = [];
        if (pinReset && pinReset.count() > 0) {
            const failedPinResets = pinReset.filter(
                item => item.get('isError') === true
            );

            const successfulPinResets = pinReset.filter(
                item => item.get('loadingFinished') === true
            );

            if (pinReset.count() === failedPinResets.count()) {
                pinResetResults.push({
                    message: 'Failed. The request was not completed. Please try again.',
                    backgroundColor: errorBackgroundColor,
                    pinTypes: ['PARENTAL', 'PURCHASE'],
                });
            } else if (pinReset.count() === successfulPinResets.count()) {
                pinResetResults.push({
                    message: 'Success! the PIN is now set to 1-2-3-4.',
                    backgroundColor: successBackgroundColor,
                    pinTypes: ['PARENTAL', 'PURCHASE'],
                });
            } else {
                pinReset.keySeq().forEach(pinType => {
                    if (pinReset.getIn([pinType, 'isError'])) {
                        pinResetResults.push({
                            message: `${pinType} PIN reset failed. Please try again.`,
                            backgroundColor: errorBackgroundColor,
                            pinTypes: [pinType]
                        });
                    }

                    if (pinReset.getIn([pinType, 'loadingFinished'])) {
                        pinResetResults.push({
                            message: `Success! ${pinType} PIN is now set to 1-2-3-4.`,
                            backgroundColor: successBackgroundColor,
                            pinTypes: [pinType]
                        });
                    }
                });
            }
        }

        return (
            <div
                style={{
                    width: '100%',
                    paddingLeft: '18px',
                    paddingRight: '18px'
                }}>
                <div className="row">
                    <div className={`col ${pinResetEquipment ? 's3' : 's4'}`} style={colStyle}>
                        <RaisedButton
                            fullWidth
                            labelStyle={labelStyle}
                            disabled={equipmentLoading || outletsUpdating}
                            label={refreshInventoryLabel}
                            onTouchTap={this.handleInventoryReload} />
                    </div>
                    <div className={`col ${pinResetEquipment ? 's3' : 's4'}`} style={hitAllButtonStyle}>
                        <RaisedButton
                            fullWidth
                            labelStyle={labelStyle}
                            disabled={equipmentLoading || outletsUpdating}
                            label="Hit All"
                            onTouchTap={this.showHitAllDialog} />

                    </div>
                    <div className={`col ${pinResetEquipment ? 's3' : 's4'}`} style={removeAllButtonStyle}>
                        <RaisedButton
                            fullWidth
                            labelStyle={labelStyle}
                            disabled={equipmentLoading || outletsUpdating}
                            onTouchTap={this.removeAll}
                            label="Remove All" />
                    </div>
                    <div className={`col ${pinResetEquipment ? 's3' : 's4'}`} style={updateAllButtonStyle}>
                        <RaisedButton
                            fullWidth
                            labelStyle={labelStyle}
                            disabled={equipmentLoading || outletsUpdating}
                            primary
                            label="Update"
                            onTouchTap={this.updateOutlets} />
                    </div>
                    <div className={`col ${pinResetEquipment ? 's3' : 's4'}`} style={cancelButtonStyle}>
                        <RaisedButton
                            labelStyle={labelStyle}
                            fullWidth
                            disabled={equipmentLoading || outletsUpdating}
                            label="Cancel"
                            onTouchTap={this.resetOutlets} />
                    </div>
                    <div className="col s3" style={{
                        display: pinResetEquipment ? '' : 'none',
                        padding: '.25rem'
                    }}>
                        <RaisedButton
                            fullWidth
                            labelStyle={labelStyle}
                            disabled={equipmentLoading || outletsUpdating}
                            onTouchTap={this.togglePinResetButtons}
                            label="Pin Reset" />
                    </div>
                </div>

                <div style={{ display: pinResetEquipment && showPinResetButtons ? '' : 'none' }}>
                    {loader}
                    <div className="row">
                        <div className="col s6" style={pinResetButtonStyle}>
                            <RaisedButton
                                fullWidth
                                labelStyle={labelStyle}
                                disabled={equipmentLoading || outletsUpdating}
                                onTouchTap={() => this.pinResetCall(['PURCHASE'], pinResetEquipment)}
                                label="Reset Purchase Pin" />
                        </div>
                        <div className="col s6" style={pinResetButtonStyle}>
                            <RaisedButton
                                fullWidth
                                labelStyle={labelStyle}
                                disabled={equipmentLoading || outletsUpdating}
                                onTouchTap={() => this.pinResetCall(['PARENTAL'], pinResetEquipment)}
                                label="Reset Parental Pin" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col s6" style={pinResetButtonStyle}>
                            <RaisedButton
                                fullWidth
                                labelStyle={labelStyle}
                                disabled={equipmentLoading || outletsUpdating}
                                onTouchTap={() => this.pinResetCall(['PURCHASE', 'PARENTAL'], pinResetEquipment)}
                                label="Reset Both" />
                        </div>
                        <div className="col s6" style={pinResetButtonStyle}>
                            <RaisedButton
                                fullWidth
                                labelStyle={labelStyle}
                                disabled={equipmentLoading || outletsUpdating}
                                onTouchTap={this.togglePinResetButtons}
                                label="Cancel" />
                        </div>
                    </div>
                </div>

                {pinResetResults.map((item, index) =>
                (<div
                    key={index}
                    className="row"
                    style={{
                        ...pinResetContainerStyle,
                        backgroundColor: item.backgroundColor
                    }}
                >
                    <div className="col s11">
                        {item.message}
                    </div>
                    <div className="col s1">
                        <FontIcon
                            className="material-icons"
                            style={{
                                color: '#ffffff',
                                fontSize: '11px',
                                padding: '0.25rem 0'
                            }}
                            onTouchTap={() => workOrderActions.pinResetReset(orderId, item.pinTypes)}
                        >
                            close
                        </FontIcon>
                    </div>
                </div>)
                )}

                <Dialog
                    title="Confirm Hit All"
                    actions={actions}
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this.hideHitAllDialog}
                >
                    You are about to send a hit to all equipment! Are you sure?
                </Dialog>

            </div >
        );
    }
}

OutletActionBar.propTypes = {
    equipmentDetails: PropTypes.object,
    orderId: PropTypes.string,
    workOrderActions: PropTypes.object,
    getTechInventoryStarted: PropTypes.func,
    userId: PropTypes.string,
    techInventoryLoading: PropTypes.bool,
    techInventory: PropTypes.object,
    orderDetails: PropTypes.object,
    schedulingSystemDetails: PropTypes.object,
    pinReset: PropTypes.object,
    orderUserId: PropTypes.string,
};

export default OutletActionBar;



// WEBPACK FOOTER //
// ./src/components/equipment/OutletActionBar.js